import { render, staticRenderFns } from "./EditPortalComponent.vue?vue&type=template&id=40223a16&scoped=true"
import script from "./EditPortalComponent.vue?vue&type=script&lang=js"
export * from "./EditPortalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40223a16",
  null
  
)

export default component.exports